import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { COMPANY, CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const isAssignableObjectType = objectType => [COMPANY, CONTACT].includes(objectType);
export const isAssignableObjectTypeId = objectTypeId => [COMPANY_TYPE_ID, CONTACT_TYPE_ID].includes(objectTypeId);
export const getCompanyUrl = subjectId => `/contacts/${PortalIdParser.get()}/company/${subjectId}`;
export const getContactUrl = subjectId => `/contacts/${PortalIdParser.get()}/contact/${subjectId}`;
export const getObjectTypeTranslated = ({
  count,
  objectType
}) => unescapedText(`genericTypes.${count === 1 ? 'singular.' : ''}${objectType}`);
const makeTooltip = ({
  errorListItems,
  i18nKey
}) => /*#__PURE__*/_jsxs("span", {
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: `${i18nKey}.body`
  }), /*#__PURE__*/_jsx("ul", {
    children: errorListItems
  })]
});
export const getAmountSelectedError = ({
  i18nKey,
  isSelectingEntireQuery
}) => isSelectingEntireQuery ? /*#__PURE__*/_jsx("li", {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    "data-test-id": "selected-block-error",
    message: `${i18nKey}.selectedBlock`
  })
}) : null;
export const getCompanyGroupError = ({
  i18nKey,
  selectedObjectsData
}) => {
  const isPartOfCompanyGroup = selectedObjectsData.filter(record => 'sales_ops_managed_exempt_from_capacity_limit' in record && record.sales_ops_managed_exempt_from_capacity_limit === 'true');
  return isPartOfCompanyGroup.length > 0 ? /*#__PURE__*/_jsx("li", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "company-group-error",
      message: `${i18nKey}.groupBlock`
    })
  }) : null;
};
export const getOwnerError = ({
  i18nKey,
  loggedInOwnerId,
  selectedObjectsData
}) => {
  if (loggedInOwnerId) {
    const recordsNotOwnerByUser = selectedObjectsData.filter(record => record.hubspot_owner_id !== loggedInOwnerId.toString());
    if (recordsNotOwnerByUser.length === 0) {
      return null;
    }
  }
  return /*#__PURE__*/_jsx("li", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "owner-block-error",
      message: `${i18nKey}.ownerBlock`
    })
  });
};
export const isDisabled = ({
  checks,
  i18nKey,
  isSelectingEntireQuery,
  loggedInOwnerId,
  selectedObjectsData
}) => {
  if (!selectedObjectsData.length) {
    return {
      disabled: true
    };
  }
  const errorListItems = checks.map(check => check({
    i18nKey,
    isSelectingEntireQuery,
    loggedInOwnerId,
    selectedObjectsData
  })).filter(error => !!error);
  if (errorListItems.length > 0) {
    return {
      disabled: true,
      disabledTooltip: makeTooltip({
        errorListItems,
        i18nKey
      })
    };
  }
  return {
    disabled: false
  };
};
export const isBETPortal = hasAllScopes => {
  /* copied from https://git.hubteam.com/HubSpot/CRM/blob/master/crm_data/static-4.83242/js/BET/permissions/DealPermissions.js#L17
   *
   * This is janky, and should be changed eventually, but we basically rely on the assumption that if the user
   * has this random BET scope, that they must be in a BET portal
   */
  return hasAllScopes('bet-enforce-deal-stage-restrictions');
};
export const shouldStandardAssignDeferRenderToBetBulkAssignWrapper = ({
  hasAllScopes,
  objectTypeId
}) => {
  const isAcceptableObjectTypeId = isAssignableObjectTypeId(objectTypeId);
  const isAcceptablePortal = isBETPortal(hasAllScopes);
  return isAcceptableObjectTypeId && isAcceptablePortal;
};